import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const CheckoutSuccessPage = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    // If this window was opened by window.open(), notify the opener and close
    if (window.opener && !window.opener.closed) {
      const sessionId = searchParams.get("session_id");
      window.opener.postMessage(
        {
          type: "STRIPE_CHECKOUT_SUCCESS",
          sessionId,
        },
        window.location.origin
      );
      window.close();
      return;
    }

    // Fallback if not opened as popup - redirect to home
    window.location.href = "/";
  }, [searchParams]);

  return (
    <div className="flex justify-center items-center min-h-screen">
      <div className="space-y-4 text-center">
        <h1 className="text-2xl font-bold text-green-600">Paiement réussi !</h1>
        <p className="text-muted-foreground">
          Cette fenêtre va se fermer automatiquement...
        </p>
      </div>
    </div>
  );
};
